// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5923":"8deedfa72baaba06","7544":"610efc1af1d0bca7"}[chunkId] + ".css";
};